<div class="card-wrapper">
  <div class="card-info">
    <div class="icon-wrapper">
      <nz-avatar
        *ngIf="avatarNzIcon"
        [nzSize]="32"
        [nzShape]="avatarNzShape"
        [nzIcon]="avatarNzIcon"
        [style]="
          'color:' +
          avatarIconColorhex +
          '; background-color:' +
          avatarIconBgColorhex
        "
      >
      </nz-avatar>
      <nz-avatar
        *ngIf="avatarImg"
        [nzSize]="32"
        [nzShape]="avatarNzShape"
        [nzSrc]="avatarImg"
        [style]="'background-color:' + avatarIconBgColorhex"
      ></nz-avatar>
    </div>
    <div>
      <div class="title-wrapper">
        <span>
          {{ title }}
        </span>
        <nz-tag [nzColor]="tagNzColor">
          {{ tagText }}
        </nz-tag>
      </div>
      <div class="description-wrapper" nz-typography nzType="secondary">
        {{ description }}
      </div>
    </div>
  </div>
  <div class="actions">
    <ng-content select="[actions-content]"> </ng-content>
  </div>
</div>
